/**
 * 화면이 Dataset 조사 사실의 편집 상태를 보는 자리. 수명은 화면이 아니라 모듈 슬롯이 든다
 * (`feature/datasetFactsEditor.ts`). 사실 섹션과 점검 화면의 요약이 같은 상태를 본다.
 */
import { useEffect, useSyncExternalStore } from "react";
import {
  acquireDatasetFactsEditor,
  type DatasetFactsEditor,
  type DatasetFactsEditorState,
} from "../feature/datasetFactsEditor";

export type DatasetFactsHandle = {
  readonly editor: DatasetFactsEditor;
  readonly state: DatasetFactsEditorState;
};

/**
 * `active` 인 동안 이 화면이 상태를 본다(`watch`). 거짓이거나 화면을 떠나면 이 화면은 그만 보고, 보는 화면이 남지
 * 않으면 다시 묻지 않는다. 편집본은 남는다 — 버리는 것은 상세가 놓을 때다(`holdDatasetFactsEditor`).
 */
export function useDatasetFactsEditor(datasetUuid: string, active: boolean): DatasetFactsHandle {
  const editor = acquireDatasetFactsEditor(datasetUuid);
  const state = useSyncExternalStore(editor.subscribe, editor.getSnapshot);
  useEffect(() => {
    editor.init();
    return active ? editor.watch() : undefined;
  }, [editor, active]);
  return { editor, state };
}
